/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente_gDolar_103_36 as Componente_gDolar_103_36,
  rec_Componente_sDolar_115_36 as Componente_sDolar_115_36,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function AnaliticaTransporte(e) {
  let t = (0, ReactCompiler.c)(48),
    { datos: n } = e,
    r;
  t[0] === n.realizadas
    ? (r = t[1])
    : ((r = (
        <Componente_gDolar_103_36
          etiqueta={`Se hicieron`}
          valor={n.realizadas}
        />
      )),
      (t[0] = n.realizadas),
      (t[1] = r));
  let i;
  t[2] === n.canceladas
    ? (i = t[3])
    : ((i = (
        <Componente_gDolar_103_36
          etiqueta={`Se cancelaron`}
          valor={n.canceladas}
        />
      )),
      (t[2] = n.canceladas),
      (t[3] = i));
  let a;
  t[4] === n.rechazadas
    ? (a = t[5])
    : ((a = (
        <Componente_gDolar_103_36
          etiqueta={`No salió nadie`}
          valor={n.rechazadas}
        />
      )),
      (t[4] = n.rechazadas),
      (t[5] = a));
  let o;
  t[6] === n.programadas
    ? (o = t[7])
    : ((o = (
        <Componente_gDolar_103_36
          etiqueta={`Sin cerrar`}
          valor={n.programadas}
        />
      )),
      (t[6] = n.programadas),
      (t[7] = o));
  let s;
  t[8] !== r || t[9] !== i || t[10] !== a || t[11] !== o
    ? ((s = (
        <div
          className={`grid grid-cols-2 gap-3 sm:grid-cols-4`}
          children={[r, i, a, o]}
        />
      )),
      (t[8] = r),
      (t[9] = i),
      (t[10] = a),
      (t[11] = o),
      (t[12] = s))
    : (s = t[12]);
  let c;
  t[13] !== n.confirmaron ||
  t[14] !== n.pedidos ||
  t[15] !== n.personasQueNoViajaron ||
  t[16] !== n.seBajaron ||
  t[17] !== n.sinContestar
    ? ((c = n.pedidos > 0 && (
        <section
          className={`rounded-2xl border border-(--border) bg-(--bg) p-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm`}
          children={[
            <span
              className={`text-(--text-h)`}
              children={[n.confirmaron, ` de `, n.pedidos, ` confirmaron`]}
            />,
            n.seBajaron > 0 && (
              <span
                className={`text-(--error)`}
                children={[
                  n.seBajaron,
                  ` se bajaron · `,
                  n.personasQueNoViajaron,
                  ` personas no viajaron`,
                ]}
              />
            ),
            n.sinContestar > 0 && (
              <span
                className={`text-(--text)`}
                children={[n.sinContestar, ` no contestaron`]}
              />
            ),
          ]}
        />
      )),
      (t[13] = n.confirmaron),
      (t[14] = n.pedidos),
      (t[15] = n.personasQueNoViajaron),
      (t[16] = n.seBajaron),
      (t[17] = n.sinContestar),
      (t[18] = c))
    : (c = t[18]);
  let l;
  t[19] !== n.calificacion ||
  t[20] !== n.contestaron ||
  t[21] !== n.encuestados ||
  t[22] !== n.llegoTarde ||
  t[23] !== n.noLlego ||
  t[24] !== n.noViajaron
    ? ((l = n.encuestados > 0 && (
        <section
          className={`rounded-2xl border border-(--border) bg-(--bg) p-4 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm`}
          children={[
            n.calificacion != null && (
              <span
                className={`text-(--text-h)`}
                children={[
                  <strong
                    className={`text-lg`}
                    children={Number(n.calificacion).toFixed(1)}
                  />,
                  ` de 5`,
                ]}
              />
            ),
            <span
              className={`text-(--text)`}
              children={[
                n.contestaron,
                ` de `,
                n.encuestados,
                ` contestaron cómo les fue`,
              ]}
            />,
            n.llegoTarde > 0 && (
              <span
                className={`text-(--warning)`}
                children={[n.llegoTarde, ` llegó tarde`]}
              />
            ),
            n.noLlego > 0 && (
              <span
                className={`text-(--error)`}
                children={[n.noLlego, ` no llegó`]}
              />
            ),
            n.noViajaron > 0 && (
              <span
                className={`text-(--error)`}
                children={[n.noViajaron, ` no viajaron`]}
              />
            ),
          ]}
        />
      )),
      (t[19] = n.calificacion),
      (t[20] = n.contestaron),
      (t[21] = n.encuestados),
      (t[22] = n.llegoTarde),
      (t[23] = n.noLlego),
      (t[24] = n.noViajaron),
      (t[25] = l))
    : (l = t[25]);
  let u;
  t[26] !== n.proveedoresPeorCalificados || t[27] !== n.rutasPeorCalificadas
    ? ((u = (n.rutasPeorCalificadas?.length > 0 ||
        n.proveedoresPeorCalificados?.length > 0) && (
        <JSXRuntime.Fragment
          children={[
            <Componente_sDolar_115_36
              titulo={`Rutas peor calificadas`}
              vacio={`Todavía no hay suficientes respuestas.`}
              filas={n.rutasPeorCalificadas}
              columna={`Nota`}
              tono={`error`}
              nota={!0}
            />,
            <Componente_sDolar_115_36
              titulo={`Proveedores peor calificados`}
              vacio={`Todavía no hay suficientes respuestas.`}
              filas={n.proveedoresPeorCalificados}
              columna={`Nota`}
              tono={`error`}
              nota={!0}
            />,
          ]}
        />
      )),
      (t[26] = n.proveedoresPeorCalificados),
      (t[27] = n.rutasPeorCalificadas),
      (t[28] = u))
    : (u = t[28]);
  let d;
  t[29] === n.rutas
    ? (d = t[30])
    : ((d = (
        <Componente_sDolar_115_36
          titulo={`Rutas que más salen`}
          vacio={`Todavía no hay viajes en este período.`}
          filas={n.rutas}
          columna={`Gasto`}
        />
      )),
      (t[29] = n.rutas),
      (t[30] = d));
  let f;
  t[31] === n.proveedores
    ? (f = t[32])
    : ((f = (
        <Componente_sDolar_115_36
          titulo={`Proveedores`}
          vacio={`Todavía no hay proveedores con viajes.`}
          filas={n.proveedores}
          columna={`Gasto`}
        />
      )),
      (t[31] = n.proveedores),
      (t[32] = f));
  let p;
  t[33] === n.areasQueSeBajan
    ? (p = t[34])
    : ((p = (
        <Componente_sDolar_115_36
          titulo={`Áreas que más se bajan`}
          vacio={`Nadie se bajó en este período.`}
          filas={n.areasQueSeBajan}
          columna={`Pagó igual`}
          tono={`error`}
        />
      )),
      (t[33] = n.areasQueSeBajan),
      (t[34] = p));
  let m;
  t[35] === n.personasQueSeBajan
    ? (m = t[36])
    : ((m = (
        <Componente_sDolar_115_36
          titulo={`Quiénes se bajan más`}
          vacio={`Nadie se bajó en este período.`}
          filas={n.personasQueSeBajan}
          columna={``}
          tono={`error`}
        />
      )),
      (t[35] = n.personasQueSeBajan),
      (t[36] = m));
  let h;
  t[37] !== f || t[38] !== p || t[39] !== m || t[40] !== u || t[41] !== d
    ? ((h = (
        <div
          className={`grid grid-cols-1 gap-4 lg:grid-cols-2`}
          children={[u, d, f, p, m]}
        />
      )),
      (t[37] = f),
      (t[38] = p),
      (t[39] = m),
      (t[40] = u),
      (t[41] = d),
      (t[42] = h))
    : (h = t[42]);
  let _;
  return (
    t[43] !== h || t[44] !== s || t[45] !== c || t[46] !== l
      ? ((_ = (
          <div className={`flex flex-col gap-4`} children={[s, c, l, h]} />
        )),
        (t[43] = h),
        (t[44] = s),
        (t[45] = c),
        (t[46] = l),
        (t[47] = _))
      : (_ = t[47]),
    _
  );
}
